import { Action, createReducer, on } from '@ngrx/store';
import { IAVCFrequencyLookup, PFSetting } from '../models/pf-settings.model';
import * as actions from '../actions';
import { IEmployeeDetailResponse } from '../../employee-detail/models/employee-detail.model';
import { IBusinessDetailResponse } from '../../businesses-detail/models/business-detail.model';

export const getBusinessKey = 'getBusiness';
export interface GetBusinessState {
  getBusinessSuccess: IBusinessDetailResponse[];
  getBusinessFailure: any;
  loaded: boolean;
}

export const initialState: GetBusinessState = {
  getBusinessSuccess: undefined,
  getBusinessFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(actions.getBusiness, (state, action) => ({
    ...state
  })),
  on(actions.getBusinessSuccess, (state, action) => ({
    ...state,
    getBusinessSuccess: action.response,
    loaded: true
  })),
  on(actions.getBusinessFailure, (state, action) => ({
    ...state,
    getBusinessFailure: action.error
  }))
);

export const getBusinessResponse = (state: GetBusinessState) => {
  if (state && state.getBusinessSuccess) return JSON.parse(JSON.stringify(state.getBusinessSuccess));
  else return null;
};

export const getEmployeeDataIsLoaded = (state: GetBusinessState) => {
  state.loaded;
};
